import { render, staticRenderFns } from "./pc-leg-iab-category-block.vue?vue&type=template&id=d8292ec6&scoped=true&"
import script from "./pc-leg-iab-category-block.vue?vue&type=script&lang=js&"
export * from "./pc-leg-iab-category-block.vue?vue&type=script&lang=js&"
import style0 from "./pc-leg-iab-category-block.vue?vue&type=style&index=0&id=d8292ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8292ec6",
  null
  
)

export default component.exports